<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
                xs="12"
                sm="6"
                class="pa-1 animate__animated animate__fadeIn"
            >
                <v-card class="soli-round">
                    <v-container>
                        <v-card-title class="soli-grey">My Agenda</v-card-title>
                        <v-btn
                            style="position: absolute; top: 0px; right: 0px"
                            plain
                            :ripple="false"
                            :class="['ma-6 ']"
                            @click="today = !today"
                        >
                            <v-icon :color="today ? 'primary' : 'secondary'"
                                >list</v-icon
                            ><small class="ml-2">{{
                                today ? "Today" : "This Week"
                            }}</small></v-btn
                        >
                        <v-container>
                            <LessonAgenda
                                v-if="is('Teacher')"
                                :events="getLessons"
                                :assignments="[]"
                                @success="$emit('success')"
                            ></LessonAgenda>
                        </v-container> </v-container
                ></v-card>
            </v-col>
            <v-col
                cols="12"
                xs="12"
                sm="6"
                class="pa-1 animate__animated animate__fadeIn"
                v-if="!!teachingHours.length"
            >
                <v-card class="soli-round">
                    <v-container>
                        <v-card-title class="soli-grey"
                            >Teaching Hours</v-card-title
                        >
                        <v-card-subtitle class="soli-grey"
                            >Total: {{ teachingHours[2] }}</v-card-subtitle
                        >
                        <v-container>
                            <trend
                                :data="teachingHours"
                                :gradient="['#6fa8dc', '#42b983', '#2c3e50']"
                                auto-draw
                                smooth
                            >
                            </trend>
                            <v-row class="justify-between pa-3">
                                <small>{{
                                    globalMomentDate(
                                        $page.props.auth.user.created_at
                                    )
                                }}</small>
                                <small>{{
                                    globalMomentDate(
                                        new Date(
                                            (new Date(
                                                $page.props.auth.user.created_at
                                            ).getTime() +
                                                new Date().getTime()) /
                                                2
                                        )
                                    )
                                }}</small>
                                <small>{{
                                    globalMomentDate(new Date())
                                }}</small>
                            </v-row>
                        </v-container>
                    </v-container></v-card
                >
            </v-col>
        </v-row></v-container
    >
</template>

<script>
import LessonAgenda from "./LessonAgenda";
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: ["myAgenda", "teachingHours"],
    components: {
        LessonAgenda,
    },
    data() {
        return {
            today: true,
        };
    },
    computed: {
        getLessons() {
            if (!this.myAgenda) return null;
            if (this.today) {
                return this.myAgenda.filter((e) => {
                    return moment(e.starts_at).isSame(
                        moment(new Date()),
                        "day"
                    );
                });
            } else {
                return this.myAgenda;
            }
        },
    },
};
</script>
